
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "jquery", version: "3.7.1", factory: () => (__webpack_require__.e("56").then(() => (() => (__webpack_require__(2257))))), eager: 0, singleton: 1, requiredVersion: "^3.7.1" }, 9713] }, uniqueName: "report" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
